<template>
    <div class="site-panel">
        <v-form ref="form">
            <v-row class="no-frame">
                <v-col class="main-first-col modal-tab no-border">
                    <c-column-header class="primary white--text mb-0" label="Notizen zur Anlage" />
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-textarea
                                v-model        = "notes.notes"
                                :readonly      = "readonly"
                                rows           = "17"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                class          = "pt-0"
                                no-resize
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <c-column-header class="primary white--text mt-5 mb-0" label="Besonderheiten" />
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-textarea
                                v-model        = "notes.comment"
                                :readonly      = "readonly"
                                rows           = "17"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                class          = "pt-0 mb-2"
                                no-resize
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <c-v-spacer />
                </v-col>
                <v-col class="main-middlle-col modal-tab no-border">
                    <c-column-header class="primary white--text mb-0" label="Notrufbesonderheiten" />
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-textarea
                                v-model        = "notes.esccomment"
                                :readonly      = "readonly"
                                rows           = "17"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                class          = "pt-0"
                                no-resize
                                hide-details
                            />
                        </v-col>
                    </v-row>


                    <c-column-header class="primary white--text mt-5 mb-0" label="Weitere Besonderheiten" />
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-textarea
                                v-model        = "notes.addcomment"
                                :readonly      = "readonly"
                                rows           = "17"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                class          = "pt-0 mb-2"
                                no-resize
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <c-v-spacer />
                </v-col>
                <v-col class="main-middlle-col modal-tab no-border">
                    <c-column-header class="primary white--text mb-1" label="Technischer Liftmanager" />
                    <v-row class="no-frame lm-border pa-3">
                        <v-col class="no-frame">
                            <v-row class="no-frame mt-1" style="margin-bottom: 19px">
                                <v-col class="no-frame">
                                    <v-switch
                                        v-model   = "notes.checkTechnicalLm"
                                        :readonly = "readonly"
                                        label     = "Check techn. Liftmanager"
                                        class     = "mt-0 pt-0"
                                        :ripple   = "false"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame mt-3">
                                <v-col class="no-frame">
                                    <span class="">Gewährleistung Sanierung</span>
                                </v-col>
                            </v-row>

                            <v-divider />

                            <v-row class="no-frame mt-0">
                                <v-col class="no-frame pr-2">
                                    <f-date-picker
                                        v-model   = "notes.startWarranty"
                                        :readonly = "readonly"
                                        label     = "Beginn"
                                    />
                                </v-col>
                                <v-col class="no-frame pl-2">
                                    <f-date-picker
                                        v-model   = "notes.endWarranty"
                                        :readonly = "readonly"
                                        label     = "Ende"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-textarea
                                v-model        = "notes.noticeTlm"
                                :readonly      = "readonly"
                                label          = "Notizen"
                                rows           = "8"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                class          = "mt-2 mb-3"
                                no-resize
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <c-v-spacer />
                </v-col>
                <v-col class="main-last-col modal-tab no-border">
                    <v-row class="no-frame">
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>

import Core          from "@/modules/core/service/Core";
import Site          from "@/modules/msd/unit/service/Site";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";
import CVSpacer      from "@/modules/core/components/utils/CVSpacer";
import FDatePicker   from "@/modules/core/components/utils/FDatePicker";

export default {
    name: "TSiteNotes",

    components: {
        CVSpacer,
        CColumnHeader,
        FDatePicker
    },
    props: {
        siteId: {
            type: Number
        },

        notes: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    notes           : null,
                    noticeTlm       : null,
                    noticeAdd       : null,
                    checkTechnicalLm: null,
                    startWarranty   : null,
                    endWarranty     : null,
                    addcomment      : null
                }
            }
        },

        readonly: {
            required: true,
            type    : Boolean
        },
    },

    data: () => ({
    }),

    methods: {
        onSave () {
            this.$refs.form.validate ();
            Site.update.note(this.siteId, this.notes, () => {
                Core.message.alert.save(this);
            });
        }
    }
}
</script>

<style scoped>

</style>